<style lang="scss" scoped>
  .card-icon-plus-call-action {
    height: 100%;
  }
</style>

<template>
  <button
    class="btn btn-bulldesk btn-bulldesk-white"
    @click="$emit('click')"
  >
    {{ __('Criar nova campanha') }}
  </button>
</template>

<script>
import CardIconPlusCallAction from '../ui/cards/CardIconPlusCallAction';

export default {
  name: 'CardCreateAutomation',

  components: {
    CardIconPlusCallAction,
  },
};
</script>
